export default {
  workflow: {
    ai: {
      askMode: 'Ask',
      agentMode: 'Agent',
      newChat: 'New Chat',
      history: 'History',
      collapse: 'Collapse',
      welcomeTitle: '👋 Hi, How can I Help you?',
      suggestion: {
        oneLine: 'Multi-NPC system with memory & personas',
        upload: 'Automated resume screening pipeline',
        testInput: 'Webhook-triggered dynamic pages',
        comment: 'Extract & process data from invoices',
        document: 'Generate the workflow document',
      },
      inputPlaceholder: "Ask, {'@'} for context",
      upload: 'Upload',
      send: 'Send',
      currentSession: 'Current Session',
      noHistory: 'No History',
      clearSession: 'Clear Session',
      clearSessionConfirm:
        'Are you sure you want to clear the current session?',
      versionHistory: 'Version History',
      executionPlan: 'Execution Plan',
      workflowPreview: 'Workflow Preview',
      keep: 'Keep',
      added: 'Added',
      modified: 'Modified',
      removed: 'Removed',
      confirmExecution: 'Confirm Execution',
      clarifyNotice: 'Please confirm the following information',
      required: 'Required',
      optional: 'Optional',
      selectNodesPrompt: 'Select nodes to optimize:',
      processing: 'Processing...',
      hideDiff: 'Hide Diff',
      showDiff: 'Show Diff',
      thinking: 'Thinking...',
      thoughtComplete: 'Thought',
      applyToCanvas: 'Apply to Canvas',
      appliedToCanvas: 'Applied to Canvas',
      undoApply: 'Undo Apply',
      generatedWorkflows: 'Generated {count} workflows',
      workflowIndex: 'Workflow {index}',
      createWorkflow: 'Create New Workflow',
      reminderLabel: 'Reminder',
      reDescribe: 'Re-describe',
      addedImages: 'Added {count} screenshots',
      screenshotName: 'Screenshot {index}',
      noVersionHistory: 'No version history',
      restoreVersion: 'Restore',
      clickNodeToViewConfig: 'Click a node to view its config',
      noConfig: 'No configuration',
      wsDisconnected: 'WebSocket disconnected',
      wsDisconnectedRetry: 'WebSocket disconnected, please retry later',
      voiceInputInProgress: 'Voice input is under development',
      selectNodesHint: 'Select nodes on the canvas, then return to input',
      selectedNodesCount: 'Selected {count} nodes',
      sessionCleared: 'Session cleared',
      workflowGenerated: 'Workflow generated',
      testMessageFailed: 'Failed to send test message',
      planExecutionStarted: 'Plan execution started',
      confirmPlanFailed: 'Failed to confirm plan',
      planRejectedResponse:
        'Okay, the plan was canceled. How would you like to adjust it?',
      rejectPlanFailed: 'Failed to cancel plan',
      confirmActionMessage: 'Confirm',
      solutionRejectedResponse:
        'Okay, canceled. How would you like to adjust it?',
      submitFailed: 'Submit failed',
      selectAtLeastOneNode: 'Please select at least one node',
      optimizeNodeProgress: 'Optimizing node: {name} ({current}/{total})',
      optimizeNodeFailed: 'Failed to optimize node {name}, please retry',
      optimizeNodesSuccess: 'Optimized {count} nodes',
      applyWorkflowSuccess: 'Applied: added {added} nodes (undoable)',
      applyWorkflowSuccessWithModified:
        'Applied: added {added} nodes, modified {modified} nodes (undoable)',
      undoApplySuccess: 'Workflow application undone',
      applyPendingWorkflowSuccess:
        'Workflow {index} applied: added {added} nodes (undoable)',
      applyPendingWorkflowSuccessWithModified:
        'Workflow {index} applied: added {added} nodes, modified {modified} nodes (undoable)',
      creatingWorkflow: 'Creating workflow {index}...',
      fileLoaded: 'File loaded: {name}',
      fileReadFailed: 'Failed to read file',
      handleFailed: 'Request failed',
      handleFailedWithMessage:
        'Sorry, an error occurred while processing your request: {message}',
      operationCancelled: 'Operation cancelled',
      undoSuccess: 'Undo successful',
      sessionCreated: 'New session created',
      sessionDeleted: 'Session deleted',
      imageTypeInvalid: 'Please upload PNG, JPG, GIF, or WebP images',
      imageSizeLimit: 'Image size cannot exceed 5MB',
      imageAdded: 'Screenshot added: {name}',
      imageReadFailed: 'Failed to read image',
      executeResourceSuggestionPlaceholder:
        'About to execute {count} resource suggestion(s)',
      placeholder: {
        executing: 'Executing, please wait...',
        clarify: 'Please answer above questions or provide more details',
        selectNodes: 'Select nodes above or enter other instructions',
        default:
          'Enter a message, press Enter to send, Shift+Enter for newline',
      },
      phase: {
        idle: 'Idle',
        clarify: 'Clarify',
        plan: 'Planning',
        confirm: 'Awaiting Confirmation',
        execute: 'Executing',
        selectNodes: 'Select Nodes',
      },
      stage: {
        intentRecognition: 'Intent Analysis',
        solutionDesign: 'Solution Design',
        parameterExtraction: 'Parameter Extraction',
        workflowGeneration: 'Workflow Generation',
        workflowOptimization: 'Workflow Optimization',
        analyzing: 'Deep Analysis',
        processing: 'Processing',
        completing: 'Final Confirmation',
        default: 'Smart Processing',
      },
      testTool: {
        label: 'Test Tool',
        title: 'Copilot Test Tool',
        type: {
          label: 'Test Type',
          preset: 'Preset Cases',
          random: 'Random Generation',
          stress: 'Stress Test',
        },
        preset: {
          select: 'Select Scenario',
          rounds: '{count} rounds',
        },
        random: {
          title: 'LLM Generation',
          domain: 'Domain',
          complexity: 'Complexity',
          rounds: 'Rounds',
          focus: 'Focus',
          focusOptional: 'Optional',
          generate: 'Generate with LLM',
          generating: 'Generating...',
          domains: {
            minecraft: 'Minecraft',
            npc: 'NPC System',
            combat: 'Combat System',
            quest: 'Quest System',
            economy: 'Economy System',
          },
          complexities: {
            simple: 'Simple',
            medium: 'Medium',
            complex: 'Complex',
          },
          focuses: {
            variable_ref: 'Variable Reference',
            context_memory: 'Context Memory',
            multi_turn: 'Multi-turn Modification',
            edge_case: 'Edge Cases',
          },
        },
        stress: {
          config: 'Stress Config',
          concurrent: 'Concurrent',
          requests: 'Requests',
        },
        cases: {
          title: 'Test Cases ({count})',
          run: 'Run Tests',
          running: 'Running...',
          insert: 'Insert Current',
          viewReport: 'View Report',
        },
        report: {
          title: 'Test Report',
          total: 'Total',
          passed: 'Passed',
          failed: 'Failed',
          avgResponse: 'Avg Response',
        },
        message: {
          generated: 'LLM generated {count} test cases',
          parseError: 'Failed to parse LLM response',
          formatError: 'LLM response format error',
          generateFailed: 'Generation failed: {error}',
          fallback: 'LLM unavailable, using fallback templates',
          emptyResponse: 'Empty response',
          requestFailed: 'Request failed',
        },
      },
      applyWorkflow: 'Apply Workflow',
      previewWorkflow: 'Preview Workflow',
      multiWorkflowNotice:
        'Found multiple matching workflows, please select one to preview:',
      reminder: {
        title: 'AI Assistant Reminder',
        v0: 'I am your AI assistant, helping you build and optimize workflows.',
        v1: 'Tip: You can use Natural Language to describe the workflow you want, and I will generate it for you.',
        v2: 'Tip: You can ask me to explain any node or the entire workflow logic.',
        v3: 'Tip: Try "Generate a test input" to help you debug your workflow.',
      },
    },
    publishModal: {
      title: 'Publish Workflow',
      okPublish: 'Publish Version',
      okPublishing: 'Publishing...',
      versionLabel: 'Version',
      versionPlaceholder: 'Enter version, e.g. v1.0.0',
      latestVersion: 'Current latest version: ',
      descriptionLabel: 'Version Description',
      descriptionPlaceholder: 'Please enter',
      rules: {
        versionRequired: 'Please enter version',
        versionFormat: 'Version format should be like v1.0.0',
      },
    },
    index: {
      title: 'My Workflows',
      createWorkflow: 'Create Workflow',
      importWorkflow: 'Import Workflow',
      importModal: {
        title: 'Import Workflow',
        uploadJsonFile: 'Upload JSON File',
        uploadHint:
          'Please upload a JSON file that matches the workflow definition format.',
        messages: {
          importSuccess: 'Import successful',
          importFailed: 'Import failed',
        },
        errors: {
          invalidJsonObject: 'Invalid data format. Expected a JSON object',
          missingName: 'Missing workflow name (name)',
          missingNodes: 'Missing node definitions (nodes) or invalid format',
          missingEdges: 'Missing edge definitions (edges) or invalid format',
          missingEntryNode: 'Missing entry node definition (entry_node)',
          parseFailed: 'Failed to parse JSON file. Please check the format',
          uploadValidFileFirst:
            'Please upload and parse a valid workflow JSON file first',
        },
      },
      allTags: 'All Tags',
      filterByMember: 'Filter by member',
      typeToSearchOrCreate: 'Type to search or create',
      searchTags: 'Search Tags',
      search: 'Search',
      empty: 'No workflows found',
      noDescription: 'No description',
      noTagsFound: 'No tags found',
      updatedAt: 'Updated at',
      creator: 'Creator',
      editor: 'Last Editor',
      addTag: 'Add Tag',
      manageTags: 'Manage Tags',
      tagColor: 'Color',
      createTag: 'Create Tag',
      createAndBindTag: 'Create and bind "{name}"',
      saveTag: 'Save Tag',
      editTag: 'Edit',
      deleteTag: 'Delete',
      tagDescriptionPlaceholder: 'Enter tag description (optional)',
      tagNameRequired: 'Please enter tag name',
      tagNameDuplicate: 'Tag name already exists',
      tagCreateSuccess: 'Tag created successfully',
      tagCreateAndBindSuccess: 'Tag created and bound successfully',
      tagUpdateSuccess: 'Tag updated successfully',
      tagDeleteSuccess: 'Tag deleted successfully',
      bindSuccess: 'Tag bound successfully',
      unbindSuccess: 'Tag unbound successfully',
      deleteTagTitle: 'Delete tag "{name}"',
      deleteTagConfirm:
        'Deleting this tag may affect workflows that are using it. Continue?',
      confirm: 'Confirm',
      cancel: 'Cancel',
      edit: 'Edit',
      clone: 'Clone',
      delete: 'Delete',
    },
    detail: {
      nav: {
        goTo: 'Go to',
        homepage: 'Homepage',
        myWorkflows: 'My Workflows',
        orchestrate: 'Orchestrate',
        triggers: 'Triggers',
        logs: 'Logs',
        test_tasks: 'Test Tasks',
      },
      triggers: {
        title: 'Triggers',
        refresh: 'Refresh',
        never: 'Never',
        columns: {
          name: 'Trigger Name',
          description: 'Description',
          status: 'Status',
          updatedAt: 'Updated At',
          lastTriggeredAt: 'Last Triggered',
          action: 'Action',
        },
        status: {
          active: 'In Service',
          disabled: 'Disabled',
        },
        messages: {
          loadFailed: 'Failed to load triggers',
          enabled: 'Trigger enabled',
          disabled: 'Trigger disabled',
          toggleFailed: 'Failed to toggle trigger status',
        },
      },
      testTasks: {
        title: 'Test Tasks',
        refresh: 'Refresh',
        defaultStartNode: 'Start Node',
        taskNameValue: 'Test Run ({startNodeName})',
        columns: {
          taskName: 'Task Name',
          startTime: 'Start Time',
          status: 'Status',
          runTime: 'Run Time',
          requestId: 'Request ID',
          executionId: 'Execution ID',
          executor: 'Executor',
          totalTokens: 'Total Tokens',
        },
      },
      edit: 'Edit',
      editInfo: 'Edit Info',
      saveNotice: 'Saving will store all workflow info, including node config',
      recordLog: 'Execution Log',
      protocolBound: 'Protocol Bound',
      updatedAt: 'Updated at',
      catalog: 'Catalog:',
      loading: 'Loading...',
    },
    executionExample: {
      title: 'Execution Examples',
      upload: 'Upload Example',
      exampleName: 'Example Name',
      exampleNamePlaceholder: 'Enter example name',
      exampleCatalog: 'Example Catalog',
      exampleCatalogPlaceholder: 'Select example catalog',
      exampleType: 'Example Type',
      exampleTypePlaceholder: 'Select example type',
      typeWorkflow: 'Workflow',
      typeNode: 'Node',
      creator: 'Creator',
      creatorPlaceholder: 'Enter creator',
      reset: 'Reset',
      viewConfig: 'View Config',
      deleteConfirm: 'Are you sure you want to delete this example?',
      delete: 'Delete',
      tableColumns: {
        exampleName: 'Example Name',
        exampleCatalog: 'Example Catalog',
        exampleType: 'Example Type',
        creator: 'Creator',
        createdAt: 'Created At',
        actions: 'Actions',
      },
    },
    scheduler: {
      status: 'Scheduler Status',
      running: 'Running',
      notStarted: 'Not Started',
      totalTasks: 'Scheduled Tasks',
      totalSuccess: 'Total Success',
      totalFailure: 'Total Failure',
      taskList: 'Scheduled Task List',
      refresh: 'Refresh',
      enabled: 'Enabled',
      disabled: 'Disabled',
      hasError: 'Has Error',
      disable: 'Disable',
      enable: 'Enable',
      viewWorkflow: 'View Workflow',
      loadFailed: 'Failed to load scheduled tasks',
      taskEnabled: 'Task enabled',
      enableFailed: 'Enable failed',
      enableTaskFailed: 'Failed to enable task',
      taskDisabled: 'Task disabled',
      disableFailed: 'Disable failed',
      disableTaskFailed: 'Failed to disable task',
      tableColumns: {
        workflow: 'Workflow',
        cron: 'Cron Expression',
        status: 'Status',
        successFailure: 'Success/Failure',
        lastExecutedAt: 'Last Executed',
        lastError: 'Last Error',
        actions: 'Actions',
      },
    },
    history: {
      title: 'Change History',
      totalCount: 'Total {count}',
      noRecords: 'No records',
      tip: 'Your edits are tracked in this session and will be cleared after leaving. (Only the latest 50 actions are kept)',
      eventTypes: {
        position: 'Move',
        add: 'Add',
        remove: 'Remove',
        init: 'Init',
        update: 'Update',
      },
      actionPrefix: {
        node: 'Node {action}',
        edge: 'Edge {action}',
      },
      actionWithName: '{action} · {name}',
      actionWithLink: '{action} · {source} → {target}',
      nodesCount: '{count} nodes',
      edgesCount: '{count} edges',
      batchSummary: '{action} · {details}',
      mixedBatch: 'Batch operation · {count} changes',
      unknown: 'Unknown',
      unknownChange: 'Unknown change',
      initialState: 'Initial state',
      currentState: 'Current state',
      stepsBack: '{count} steps back',
      stepsForward: '{count} steps forward',
      justNow: 'Just now',
      minutesAgo: '{count} minutes ago',
      hoursAgo: '{count} hours ago',
      daysAgo: '{count} days ago',
      loadToCurrent: 'Load to Current',
      clearHistory: 'Clear history',
      clearHistoryConfirm: 'Are you sure you want to clear all change history?',
    },
    floatingActions: {
      zoomOut: 'Zoom out',
      zoomIn: 'Zoom in',
      selectNodes: 'Select nodes',
      dragCanvas: 'Drag canvas',
      optimizeLayout: 'Optimize layout',
      fitView: 'Fit view',
      addNode: 'Add node',
      nodes: 'Nodes',
    },
    actions: {
      validateIssues: 'Found {count} configuration issues',
      issuesCount: '{count} issues',
      save: 'Save',
      undo: 'Undo',
      redo: 'Redo',
      history: 'History',
      testRun: 'Test Run',
      testConfig: 'Test Config',
      publish: 'Publish',
      version: 'Version',
      export: 'Export',
      exportJson: 'Export Json',
      exportSuccess: 'Export successful',
      collaborationConnected:
        'Collaboration service connected ({count} online)',
      collaborationDisconnected: 'Collaboration service disconnected/offline',
      cannotResetWhileOthersOnline:
        'Cannot reset collaboration data while other users are online',
      connected: 'Connected',
      offline: 'Offline',
      otherOnlineUsers: 'Other online users',
      onlineUsers: 'Online users',
      singleEntryNodeRequired: 'Workflow can only have one entry node',
      entryNodeRequired: 'Workflow must have an entry node',
      testRunPopover: {
        title: 'Choose the start node to run',
        inputGroup: 'Input',
        triggerGroup: 'Trigger',
        unpublished: 'Unpublished',
        triggerHint: 'Please publish unpublished triggers before running.',
        noRunnableEntry:
          'No runnable entry is available. Publish the trigger or check the entry-node configuration first.',
      },
      workflowValidationError:
        'Workflow configuration is incorrect, please check the checklist and fix before saving',
      nodeName: 'Node {id}',
      help: 'Help',
      workflowDocument: 'Workflow Doc',
      autoLayout: 'Auto Layout',
      saveFailed: 'Save failed',
      backendError: 'Backend error',
      fieldNames: {
        promptVars: 'Prompt variables',
        inputVars: 'Input variables',
        outputVars: 'Output variables',
        modelName: 'Model name',
        name: 'Name',
        description: 'Description',
        itemIndex: '{field} item {index}',
      },
      publishPopover: {
        title: 'Publish',
        latestVersion: 'Latest Version',
        versionLabel: 'Version',
        versionPlaceholder: 'e.g. V1.1.0',
        versionDescription: 'Version Description',
        versionDescriptionPlaceholder: 'Enter Publish update description',
        updateProtocolTargets: 'Update Protocol Targets',
        selectProtocol: 'Select Identifier',
        selectProtocolPlaceholder: 'Select identifier(s) to update',
        protocolTargeted: 'Targeted',
        protocolNotTargeted: 'Not Targeted',
        publishUpdate: 'Publish Update',
        workflowAsTool: 'Workflow as tool',
        publishAsTool: 'Publish as Tool',
        toolUpdate: 'Tool Update',
        publishAsTemplate: 'Publish as Template',
        triggerActivated:
          'Publish succeeded. Triggers in this workflow are now active.',
      },
    },
    nodes: {
      common: {
        model: 'Model',
        modelName: 'Model Name',
        inputVars: 'Input Variables',
        outputVars: 'Output Variables',
        noDescription: 'No description',
        notConfigured: 'Not Configured',
      },
      aggregator: {
        noGroups: 'No aggregation groups',
        noInputVars: 'No input variables',
        group: 'Group',
      },
      conditional: {
        tip: "Tip: {'{}'} represents a variable",
        noBranches: 'No branches',
        defaultBranch: 'Default Branch',
        branch: 'Branch',
        and: 'AND',
        or: 'OR',
      },
      intent: {
        description: 'Description',
        promptVars: 'Prompt Variables',
        option: 'Option',
      },
      loop: {
        countLoop: 'Count Loop',
        whileLoop: 'While Loop',
        forEachLoop: 'For Each Loop',
        loop: 'Loop',
        count: 'Count',
        loopCountVar: 'Loop Count Variable',
        collection: 'Collection',
        collectionKey: 'Collection Key',
        condition: 'Condition',
        dropHint: 'Drag nodes here as loop body, hold Ctrl to drag out of loop',
        notSet: 'Not Set',
        notConfigured: 'Not Configured',
      },
      subworkflow: {
        referencedWorkflow: 'Referenced Workflow',
        inputMapping: 'Input Mapping',
      },
    },
  },
};
